import { Container, Title, Text, Button, Group, Stack } from "@mantine/core";
import {
    IconBrandGithub,
    IconBrandLinkedin,
    IconMail,
} from "@tabler/icons-react";
import { motion } from "framer-motion";
import classes from "./Hero.module.css";

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.2,
            delayChildren: 0.1,
        },
    },
};

const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            type: "spring",
            stiffness: 100,
            damping: 12,
        },
    },
};

export function Hero({ data }) {
    return (
        <div className={classes.hero}>
            <Container size='lg'>
                <div className={classes.inner}>
                    <motion.div
                        variants={containerVariants}
                        initial='hidden'
                        animate='visible'>
                        <Stack gap='xl'>
                            <motion.div variants={itemVariants}>
                                <Text size='xl' fw={500} c='dimmed' mb='sm'>
                                    Ahoj, jsem
                                </Text>
                                <Title className={classes.title} order={1}>
                                    {data.personalInfo.name}
                                </Title>
                                <Title
                                    className={classes.subtitle}
                                    order={2}
                                    c='dimmed'
                                    fw={400}>
                                    {data.personalInfo.title}
                                </Title>
                            </motion.div>

                            <motion.div variants={itemVariants}>
                                <Text size='lg' maw={600} c='dimmed'>
                                    {data.personalInfo.tagline}
                                </Text>
                            </motion.div>

                            <motion.div variants={itemVariants}>
                                <Group gap='md'>
                                    <Button
                                        component='a'
                                        href={`mailto:${data.personalInfo.email}`}
                                        size='lg'
                                        leftSection={<IconMail size={20} />}
                                        variant='filled'>
                                        Kontaktujte mě
                                    </Button>
                                    <Button
                                        component='a'
                                        href={data.social.github}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        size='lg'
                                        leftSection={
                                            <IconBrandGithub size={20} />
                                        }
                                        variant='light'>
                                        GitHub
                                    </Button>
                                    <Button
                                        component='a'
                                        href={data.social.linkedin}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        size='lg'
                                        leftSection={
                                            <IconBrandLinkedin size={20} />
                                        }
                                        variant='light'>
                                        LinkedIn
                                    </Button>
                                </Group>
                            </motion.div>
                        </Stack>
                    </motion.div>
                </div>
            </Container>
        </div>
    );
}
